import React from "react";
import { createContext, useState } from "react";

export const FilterContext = createContext();

const FilterProvider = ({ children }) => {

    const [selectedLendFilterValues, setSelectedLendFilterValues] = useState({});

    return <FilterContext.Provider value={{ selectedLendFilterValues, setSelectedLendFilterValues }}>{children}</FilterContext.Provider>
};

export default FilterProvider;